import React from 'react';
import PropTypes from 'prop-types';
import DiscountsListFilters from './DiscountsListFilters';
import DeleteAction from 'components/field/DropDownActionsMenu/DeleteAction';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import ResourceList from 'components/list/Container/ResourceList';
import Table from 'components/table/Table';
import TextField from 'components/field/TextField';
import listQueryFilter from 'components/hoc/listQueryFilter';
import { deleteDiscount } from 'store/actions/discounts/deleteDiscounts';
import { fetchDiscounts } from 'store/actions/discounts/fetchDiscounts';
import theme from 'theme/theme';

const DiscountsList = (props) => {
    const {
        actionType,
        location,
        resource,
        updateQuery,
    } = props;

    return (
        <div>
            <DiscountsListFilters
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            />

            <ResourceList
                action={ fetchDiscounts }
                actionType={ actionType }
                location={ location }
                resource={ resource }
                updateQuery={ updateQuery }
            >
                <Table
                    colorToggle={ {
                        condition: false,
                        color: theme.palette.gray,
                        key: 'is_enabled',
                    } }
                >
                    <TextField
                        { ...props }
                        column={ {
                            sortable: false,
                            width: '30%',
                        } }
                        source='title'
                        label='resources.discounts.fields.title'
                    />

                    <DropDownActionsMenu
                        column={ {
                            align: 'center',
                            link: false,
                            width: '10%',
                        } }
                        source='actions'
                    >
                        <EditAction />

                        <DeleteAction action={ deleteDiscount } />
                    </DropDownActionsMenu>
                </Table>
            </ResourceList>
        </div>
    );
};

DiscountsList.propTypes = {
    actionType: PropTypes.string.isRequired,
    location: PropTypes.object,
    resource: PropTypes.string.isRequired,
    translate: PropTypes.func.isRequired,
    updateQuery: PropTypes.func.isRequired,
};

export default listQueryFilter(DiscountsList);



// WEBPACK FOOTER //
// ./src/pages/discounts/list/DiscountsList.js